export const DATA = {
  StepOne: {
    dni: false,
    genero: false
  },
  PatientDataForm: {
    nombre: false,
    apellido: false,
    fechaNacimiento: false,
    telefono: false,
    calle: false,
    numero: false,
    piso: false,
    departamento: false,
    email: false,
    localidad: false,
    provincia: false,
    tipoSeguridadSocial: false,
    codigoAfiliado: false,
    altura: false,
    peso: false,
    aniosConDiabetes: false,
    tieneAntecedentesGlaucoma: false,
    informacionAdicional: false
  },
  PhaseOne: {
    nombre: false,
    apellido: false,
    fechaNacimiento: false,
    telefono: false,
    calle: false,
    numero: false,
    piso: false,
    departamento: false,
    email: false,
    localidad: false,
    provincia: false,
    tipoSeguridadSocial: false,
    codigoAfiliado: false
  },
  PhaseTwo: {
    fecha: false,
    paciente_id: false,
    tipo: false,
    estado: false,
    informe: false,
    revisarProfesional: false,
    altura: false,
    peso: false,
    aniosConDiabetes: false,
    tieneAntecedentesGlaucoma: false,
    informacionAdicional: false
  }
}

export const OPTIONAL_FIELDS = {
  dni: false,
  genero: false,
  nombre: false,
  apellido: false,
  fechaNacimiento: false,
  telefono: false,
  calle: false,
  numero: false,
  piso: true,
  departamento: true,
  email: false,
  localidad: false,
  provincia: false,
  tipoSeguridadSocial: false,
  codigoAfiliado: true,
  fecha: false,
  paciente_id: true,
  tipo: true,
  estado: true,
  informe: true,
  revisarProfesional: true,
  altura: true,
  peso: true,
  aniosConDiabetes: true,
  tieneAntecedentesGlaucoma: false,
  informacionAdicional: true
}
